/** The portal's recitation log (docs/09 §2 «التسميع»): results and live sessions in a period. */
import { z } from "zod";
const Person = z.object({ id: z.uuid(), name: z.string() });
export const RecitationLogQuery = z.object({
    from: z.iso.date(),
    to: z.iso.date(),
    circleId: z.uuid().optional(),
});
export const RecitationLogResponse = z.object({
    results: z.array(z.object({
        id: z.uuid(),
        decision: z.enum(["passed", "repeat", "partial"]),
        kind: z.string().nullable(),
        range: z.string().nullable(),
        /** false: recorded in person, without a live session. */
        live: z.boolean(),
        revision: z.number(),
        student: Person,
        teacher: Person,
        circle: Person,
        recordedAt: z.string(),
    })),
    sessions: z.array(z.object({
        id: z.uuid(),
        status: z.string(),
        origin: z.string(),
        student: Person,
        teacher: Person.nullable(),
        circle: Person,
        requestedAt: z.string().nullable(),
        durationSeconds: z.number().nullable(),
        endReason: z.string().nullable(),
    })),
    /** True when a list reached its limit and the period should be narrowed. */
    truncated: z.boolean(),
});
//# sourceMappingURL=recitation-log.js.map